import { combineReducers } from "redux";
import authenticationSlice from "./slices/authenticationSlice";
import companySlice from "./slices/companySlice";
import branchSlice from "./slices/branchSlice";
export default combineReducers({
    authenticationSlice,
    companySlice,
    branchSlice,
});
